import {Component, HostListener} from '@angular/core';
import {DocumentsService} from '../../../services/documents.service';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'documents-view-modal',
    templateUrl: './documents-view-modal.component.html',
    styleUrls: ['./documents-view-modal.component.scss']
})
export class DocumentsViewModalComponent {
    constructor(public ds: DocumentsService,
                public urlService: UrlService) {
        this.urlService.modalOpened.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.ds.hideImage(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-view-modal/documents-view-modal.component.ts